<template>
  <article class="projects">
    <h1 class="border-bottom mb-4">
      Projects
    </h1>
    Coming soon
  </article>
</template>

<script>
export default {
  name: 'PageProjects'
}
</script>
